import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import PostalCodes from './PostalCodes'
import { TARGETING_MODES, activeTargetingPlatforms } from '../targeting'
import { splitCountriesByPlatform } from './postalCodesReducer'
import { useTargeting } from '../TargetingContext'

import { SecondaryButton } from 'components/Shared/Button'
import { useCampaignSetup } from 'components/Recommendations/Campaign/Context/CampaignSetupContext'
import { derivePlatformSelectionFromSetup } from 'components/Recommendations/Campaign/platform'

export default function PostalCodeList({ tc, onChange, disabled = false, targetingMode, isFirstTc = false }) {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()
  const { setup } = useCampaignSetup()
  const { value: targeting } = useTargeting()
  const tcTargeting = useMemo(() => targeting.find((x) => x.tc === tc), [targeting, tc])
  const platforms = useMemo(() => activeTargetingPlatforms(derivePlatformSelectionFromSetup(setup)), [setup])

  const onPostalCodesChange = useCallback(
    ({ countries }) => {
      const split = splitCountriesByPlatform(countries)
      const payload = {}
      for (const platform of platforms) {
        payload[platform] = {
          ...tcTargeting?.[platform],
          targeting_mode: targetingMode,
          postal_codes: { countries: split[platform] },
        }
      }
      onChange(payload)
    },
    [onChange, platforms, targetingMode, tcTargeting],
  )

  if (targetingMode !== TARGETING_MODES.postalCodes) {
    return null
  }

  return (
    <>
      <div className="postal-codes">
        {isOpen && (
          <PostalCodes
            tc={tc}
            isOpen={isOpen}
            onDone={onPostalCodesChange}
            setOpen={(open) => setIsOpen(open)}
            isFirstTc={isFirstTc}
          />
        )}
        <SecondaryButton
          text={t('common.edit')}
          color="navy"
          size="small"
          fullWidth={false}
          type="button"
          classNames="geo-targeting__button"
          onClick={(e) => {
            e.preventDefault()
            setIsOpen(!isOpen)
          }}
          disabled={disabled}
        />
      </div>
    </>
  )
}

PostalCodeList.propTypes = {
  tc: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  targetingMode: PropTypes.string,
  isFirstTc: PropTypes.bool,
}
